import { QuoteType, TradeInForceType, TradeOrderType } from "../models/trade/trade.model";
import { FormatHelpers } from "./format-helpers";

interface TradeOrderMessageResult {
    title: string;
    message: string;
}

export class TradeOrderMessageHelpers {
    public static getMessage(isBuy: boolean, quoteType: QuoteType, trderOrderType: TradeOrderType | null, quoteQuantity: number, tif: TradeInForceType, symbol: string, price: number, accountName: string): TradeOrderMessageResult {
        const result: TradeOrderMessageResult = {
            title: '',
            message: ''
        };

        result.title = isBuy ? '<span class="green">Buy</span>' : '<span class="red">Sell</span>';
        result.title += ` Order for ${symbol}`;

        const quoteQuantityString = `${quoteType == QuoteType.Shares ? '' : '$'}${FormatHelpers.numberToStringThousandSeparators(quoteQuantity, true)}${quoteType == QuoteType.Shares ? ' Shares' : ''}`;
        const shouldDisplayPrice = trderOrderType != TradeOrderType.Market;
        const priceString = shouldDisplayPrice ? `$${FormatHelpers.numberToStringThousandSeparators(price, true)}` : '';
        const trderOrderTypeString = trderOrderType == null ? '' : ` ${trderOrderType}`;

        result.message = isBuy ? '<span class="green b">Buy</span>' : '<span class="red b">Sell</span>';
        result.message += ` <span class="b">${quoteQuantityString}</span> of <span class="b">${symbol}</span>`;
        result.message += ` at <span class="b">${priceString}${trderOrderTypeString}</span><br/>active for <span class="b">1 ${tif}</span> in <span class="b">${accountName}</span>`;

        result.message = `<span class="trade-message">${result.message}</span>`;
        return result;
    }
}